import React from 'react';
import { Link } from 'react-router-dom';

const PRIMARY_BLUE = '#0B5ED7';
const PRIMARY_BLUE_HOVER = '#0A58CA';

const ProjectCard = ({ image, title, description, link }) => {
  const styles = {
    rootFont: `
      .project-serif-root, .project-serif-root * {
        font-family: Georgia, "Times New Roman", Times, serif;
        letter-spacing: .01em;
      }
    `,
    card: {
      backgroundColor: '#fff',
      border: '1px solid #e5e7eb',         // borde sutil
      borderRadius: 0,                      // sin bordes redondeados
      boxShadow: '0 1px 2px rgba(0,0,0,.05)',
      overflow: 'hidden',
      transition: 'border-color .15s ease, box-shadow .15s ease',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      maxWidth: 320,                        // más estrecha
      margin: '0 auto',
    },
    image: {
      width: '100%',
      height: 180,
      objectFit: 'cover',
      display: 'block',
      background: '#f3f4f6',
      borderBottom: '1px solid #eef2f7',
    },
    content: {
      padding: '12px 14px 14px',
      textAlign: 'left',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      gap: 10,
    },
    title: {
      fontSize: '1rem',
      fontWeight: 700,
      margin: 0,
      color: '#111827',
      lineHeight: 1.25,
    },
    description: {
      fontSize: '.94rem',
      color: '#4b5563',
      margin: 0,
      lineHeight: 1.45,
    },
    button: {
      display: 'inline-block',
      width: '100%',
      padding: '10px 14px',
      backgroundColor: PRIMARY_BLUE,        // azul elegante
      border: `1px solid ${PRIMARY_BLUE}`,
      color: '#fff',
      textDecoration: 'none',
      textAlign: 'center',
      fontWeight: 700,
      borderRadius: 0,                       // sin radios
      transition: 'background-color .15s ease, border-color .15s ease',
      cursor: 'pointer',
      marginTop: 6,
    },
  };

  return (
    <>
      <style>{styles.rootFont}</style>
      <div
        className="project-serif-root"
        style={styles.card}
        onMouseOver={(e) => { e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,.08)'; e.currentTarget.style.borderColor = '#cbd5e1'; }}
        onMouseOut={(e) => { e.currentTarget.style.boxShadow = '0 1px 2px rgba(0,0,0,.05)'; e.currentTarget.style.borderColor = '#e5e7eb'; }}
      >
        <img src={image} alt={title} style={styles.image} />

        <div style={styles.content}>
          <div>
            <h3 style={styles.title}>{title}</h3>
            <p style={styles.description}>{description}</p>
          </div>

          <Link
            to={link}
            style={styles.button}
            onMouseOver={(e) => { e.target.style.backgroundColor = PRIMARY_BLUE_HOVER; e.target.style.borderColor = PRIMARY_BLUE_HOVER; }}
            onMouseOut={(e) => { e.target.style.backgroundColor = PRIMARY_BLUE; e.target.style.borderColor = PRIMARY_BLUE; }}
          >
            Ir ahora
          </Link>
        </div>
      </div>
    </>
  );
};

export default ProjectCard;
